import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { M as MountedOverlaysAndProvider } from '../MountedOverlaysAndProvider/MountedOverlaysAndProvider.js';
import { B as BiomeShadowRootContext } from '../shadowRootContext/shadowRootContext.js';
import { B as BiomeWindowSizeProvider } from '../windowSizeContext/windowSizeContext.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import '@emotion/react';
import { S as SetWindowSize, D as DEFAULT_RESIZE_DEBOUNCE_TIME } from '../SetWindowSize/SetWindowSize.js';
import { M as MountedTooltipOverlayAndProvider } from '../MountedTooltipOverlayAndProvider/MountedTooltipOverlayAndProvider.js';
import { a as BiomePortalIdProvider } from '../BiomePortalIdProvider/BiomePortalIdProvider.js';
import { T as ToggleableThemeProvider, B as BiomeThemeProvider } from '../ToggleableThemeProvider/ToggleableThemeProvider.js';

var name = "@biom3/react";
var version = "0.25.21";
var license = "Apache-2.0";
var repository = {
	type: "git",
	url: "git+https://github.com/immutable/biom3.git"
};
var scripts = {
	typecheck: "tsc --noEmit",
	lint: "npm run typecheck && npm run lint:check",
	"lint:check": "biome check ./",
	"lint:check:fix": "biome check --apply ./",
	"format:fix": "biome format --write ./",
	dev: "",
	test: "npm run test:cy:run; npm run test:jest:run",
	"test:cy:ci": "NODE_ENV=test cypress run --component --env coverage=true --record --parallel --browser chrome --ci-build-id ${CI_BUILD_NUMBER}",
	"test:cy:open": "NODE_ENV=test cypress open --component",
	"test:cy:run": "NODE_ENV=test cypress run --component",
	"test:cy:run:localcov": "NODE_ENV=test cypress run --component --browser Brave --env coverage=true",
	"test:jest:run": "NODE_ENV=test jest",
	"test:jest:ci": "NODE_ENV=test jest --coverage",
	coverage: "npx nyc report --check-coverage",
	build: "rollup -c",
	pack: "npm pack",
	"publish-package": "if can-npm-publish; then cd dist; npm publish --access public; else echo 'Skipping package npm publish'; fi"
};
var devDependencies = {
	"@babel/plugin-transform-runtime": "^7.24.3",
	"@babel/preset-env": "^7.20.2",
	"@babel/preset-react": "^7.18.6",
	"@babel/preset-typescript": "^7.21.0",
	"@babel/runtime": "^7.24.4",
	"@cypress/code-coverage": "^3.11.0",
	"@emotion/babel-plugin": "^11.10.6",
	"@emotion/babel-preset-css-prop": "^11.10.0",
	"@emotion/cache": "^11.11.0",
	"@figma/code-connect": "^1.0.1",
	"@istanbuljs/nyc-config-typescript": "^1.0.2",
	"@jest/globals": "^29.5.0",
	"@repo/jest-config": "*",
	"@repo/nyc-config": "*",
	"@repo/ts-config": "*",
	"@rollup/plugin-alias": "^5.1.0",
	"@rollup/plugin-babel": "^6.0.4",
	"@rollup/plugin-commonjs": "^25.0.7",
	"@rollup/plugin-json": "^6.1.0",
	"@rollup/plugin-node-resolve": "^15.2.3",
	"@rollup/plugin-typescript": "^11.1.6",
	"@testing-library/jest-dom": "^6.1.3",
	"@testing-library/react": "^14.0.0",
	"@types/lodash.debounce": "^4.0.7",
	"@types/lodash.get": "^4.4.7",
	"@types/lodash.isequal": "^4.5.6",
	"@types/lodash.throttle": "^4.1.7",
	"@types/react": "^18.0.33",
	"@types/react-dom": "^18.0.9",
	"@types/react-is": "^17.0.3",
	"babel-jest": "^29.5.0",
	"babel-plugin-istanbul": "^6.0.0",
	"babel-plugin-lodash": "^3.3.4",
	"babel-plugin-rewire-exports": "^2.3.0",
	"babel-plugin-tsconfig-paths-module-resolver": "^1.0.4",
	"can-npm-publish": "^1.3.6",
	cypress: "^13.13.2",
	"cypress-real-events": "^1.12.0",
	"fork-ts-checker-webpack-plugin": "^8.0.0",
	jest: "^29.5.0",
	"jest-environment-jsdom": "^29.7.0",
	next: "~13.4.19",
	"next-router-mock": "^0.9.10",
	"node-polyfill-webpack-plugin": "^2.0.1",
	react: "^18.2.0",
	"react-dom": "^18.2.0",
	"react-router-dom": "^6.14.2",
	rollup: "^4.10.0",
	"rollup-plugin-analyzer": "^4.0.0",
	"rollup-plugin-cleaner": "^1.0.0",
	"rollup-plugin-dts": "^6.1.0",
	"rollup-plugin-peer-deps-external": "^2.2.4",
	"ts-jest": "^29.1.0",
	typescript: "^5.4.5",
	"whatwg-fetch": "^3.6.19"
};
var peerDependencies = {
	"@emotion/react": "^11.11.4",
	"@rive-app/react-canvas-lite": "^4.9.0",
	"embla-carousel-react": "^8.0.4",
	"framer-motion": "^10.12.12",
	react: "^18.2.0",
	"react-dom": "^18.2.0"
};
var dependencies = {
	"@biom3/design-tokens": "*",
	"@imtbl/image-resizer-utils": "*",
	csstype: "^3.1.2",
	"hls.js": "^1.5.11",
	localforage: "^1.10.0",
	"lodash.debounce": "^4.0.8",
	"lodash.get": "^4.4.2",
	"lodash.isequal": "^4.5.0",
	"lodash.throttle": "^4.1.1",
	"react-is": "^18.2.0",
	"react-keyed-flatten-children": "^3.0.0",
	"ts-deepmerge": "^6.2.0"
};
var sideEffects = false;
var main = "./src/index.ts";
var module = "./src/index.ts";
var types = "./src/index.ts";
var files = [
	"src/**/*",
	"index.ts"
];
var packageJson = {
	name: name,
	version: version,
	license: license,
	repository: repository,
	scripts: scripts,
	devDependencies: devDependencies,
	peerDependencies: peerDependencies,
	dependencies: dependencies,
	sideEffects: sideEffects,
	main: main,
	module: module,
	types: types,
	files: files
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
console.log("\n  @biom3/react\n  \n  version: ".concat(packageJson.version, "\n\n"));
function BiomeCombinedProviders(props) {
  var children = props.children,
    skipFontLoad = props.skipFontLoad,
    withThemeToggle = props.withThemeToggle,
    _props$resizeDebounce = props.resizeDebounceDuration,
    resizeDebounceDuration = _props$resizeDebounce === void 0 ? DEFAULT_RESIZE_DEBOUNCE_TIME : _props$resizeDebounce,
    modalContainerId = props.modalContainerId,
    drawerContainerId = props.drawerContainerId,
    popoverContainerId = props.popoverContainerId,
    toastContainerId = props.toastContainerId,
    shadowRoot = props.shadowRoot,
    globalSx = props.globalSx;
  var _ref = withThemeToggle ? _objectSpread(_objectSpread({}, props), {}, {
      theme: undefined
    }) : _objectSpread(_objectSpread({}, props), {}, {
      autoPickTheme: undefined,
      lightTheme: undefined,
      darkTheme: undefined
    }),
    autoPickTheme = _ref.autoPickTheme,
    lightTheme = _ref.lightTheme,
    darkTheme = _ref.darkTheme,
    theme = _ref.theme;
  var wrappedChildren = jsxs(BiomeWindowSizeProvider, {
    children: [jsx(SetWindowSize, {
      resizeDebounceDuration: resizeDebounceDuration
    }), jsx(MountedTooltipOverlayAndProvider, {
      children: jsx(MountedOverlaysAndProvider, {
        modalContainerId: modalContainerId,
        drawerContainerId: drawerContainerId,
        popoverContainerId: popoverContainerId,
        toastContainerId: toastContainerId,
        children: children
      })
    })]
  });
  return jsx(BiomePortalIdProvider, {
    children: jsx(BiomeShadowRootContext.Provider, {
      value: shadowRoot,
      children: withThemeToggle ? jsx(ToggleableThemeProvider, {
        lightTheme: lightTheme,
        darkTheme: darkTheme,
        globalSx: globalSx,
        autoPickTheme: autoPickTheme,
        skipFontLoad: skipFontLoad,
        children: wrappedChildren
      }) : jsx(BiomeThemeProvider, {
        theme: theme,
        globalSx: globalSx,
        skipFontLoad: skipFontLoad,
        children: wrappedChildren
      })
    })
  });
}

export { BiomeCombinedProviders as B };
//# sourceMappingURL=BiomeCombinedProviders.js.map
